<template>
  <div v-if="projectOneUrl && projectOneUrl.length > 0" class="cart-select-p1">
    <a qaid="customize-btn" class="button button--secondary button--block" :href="projectOneUrl" target="_blank">
      <i class="material-icons colorWheel" />
      <span v-html="bp('customize')" />
    </a>
  </div>
</template>
<script>
export default {
  name: 'PdpCustomizeProductButton',
  props: {
    projectOneUrl: {
      type: String,
      default: '',
    },
  },
};
</script>
